import EventApi from '@apis/event/EventApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetEventsParams } from '@models/event/request';

const eventQueries = createQueryKeys('events', {
    list: (params: Omit<GetEventsParams, 'page'>) => ({
        queryKey: [params],
    }),
    detail: (eventId: string) => ({
        queryKey: ['detail', eventId],
        queryFn: () => EventApi.getEvent(eventId),
    }),
    attendanceProgress: (eventId:string) => ({
        queryKey: ['attendanceProgress', eventId],
        queryFn: () => EventApi.getAttendanceProgress(eventId),
    }),
    attendancePolicy: (eventId: string) => ({
        queryKey: ['attendancePolicy', eventId],
        queryFn: () => EventApi.getAttendancePolicy(eventId),
    }),
});

export default eventQueries;
